var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_4195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.375 7.4375C11.375 8.69258 10.9676 9.85195 10.2812 10.7926L13.743 14.257C14.0848 14.5988 14.0848 15.1539 13.743 15.4957C13.4012 15.8375 12.8461 15.8375 12.5043 15.4957L9.04258 12.0312C8.10195 12.7203 6.94258 13.125 5.6875 13.125C2.5457 13.125 0 10.5793 0 7.4375C0 4.2957 2.5457 1.75 5.6875 1.75C8.8293 1.75 11.375 4.2957 11.375 7.4375ZM5.6875 11.375C6.20458 11.375 6.7166 11.2732 7.19432 11.0753C7.67204 10.8774 8.1061 10.5874 8.47173 10.2217C8.83736 9.8561 9.1274 9.42204 9.32528 8.94432C9.52315 8.4666 9.625 7.95458 9.625 7.4375C9.625 6.92042 9.52315 6.4084 9.32528 5.93068C9.1274 5.45296 8.83736 5.0189 8.47173 4.65327C8.1061 4.28764 7.67204 3.9976 7.19432 3.79972C6.7166 3.60185 6.20458 3.5 5.6875 3.5C5.17042 3.5 4.6584 3.60185 4.18068 3.79972C3.70296 3.9976 3.2689 4.28764 2.90327 4.65327C2.53764 5.0189 2.2476 5.45296 2.04972 5.93068C1.85185 6.4084 1.75 6.92042 1.75 7.4375C1.75 7.95458 1.85185 8.4666 2.04972 8.94432C2.2476 9.42204 2.53764 9.8561 2.90327 10.2217C3.2689 10.5874 3.70296 10.8774 4.18068 11.0753C4.6584 11.2732 5.17042 11.375 5.6875 11.375Z",
    fill: "#9CA3AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_4195"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.75H14V15.75H0V1.75Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5d309c86439aa27db13c1e3cc9b17241.svg";
export { ForwardRef as ReactComponent };